goog.provide('el8.appshared.rxRefillRequest');

goog.require('el8.appchart.dialog.ordermed.fulfillRefill');
goog.require('el8.appchart.permissions');
goog.require('el8.appshared.dialog.approveControlledMed');
goog.require('el8.appshared.dialog.approveControlledMedPrintOnly');
goog.require('el8.ptdata.rxRefillRequests');
goog.require('el8.template.render.rxRefillRequestForm');
goog.require('el8.util.amplitude.prescriptionFormHelpers');



el8.appshared.rxRefillRequest.approve = function(item, container, closeFn) {

    if (container.contents().length) { return; }

    // First, populate container with form
    container.html(el8.template.render.rxRefillRequestForm.approval());

    var authRefillsField = el8.service.infoField.addInfoField({
        field: $(':input[name="authRefills"]', container),
        infoText: '#...'
    });
    var noteField = el8.service.infoField.addInfoField({
        field: $(':input[name="note"]', container),
        infoText: 'note to pharmacy...'
    });

    var approveBtn = $('button[name="approve"]', container);
    var cancelBtn = $('button[name="cancel"]', container);

    // Initialize authRefills
    authRefillsField.setVal(item.getAuthRefills());

    var validate = function() {
        var refillsVal = authRefillsField.getVal();
        var note = noteField.getVal();
        if (refillsVal === '') {
            return {result: false, msg: 'Number of refills cannot be empty.'};
        } else if (isNaN(refillsVal) || (refillsVal.indexOf('.') !== -1) || (refillsVal.indexOf('/') !== -1)) {
            return {result: false, msg: 'Number of refills must be a whole number, with no decimals.'};
        } else if (note && note.trim().length > 70) {
            return {result: false, msg: 'Note exceeds limit of 70 characters.'};
        }
        return {result: true};
    };

    approveBtn.on('click', function(e) {
        var validated = validate();
        if (validated['result']) {
            var authRefills = authRefillsField.getVal();
            var note = noteField.getVal();
            el8.util.amplitude.startCompleteChangeNumberRefillRenewalRxResponse(
                'Approve Rx', String(item.getAuthRefills()) !== authRefills, Boolean(note)
            );
            if (!item.isMedicationControlled() || el8Globals.FEATURES.MDToolboxEPCS) {
                el8.appchart.dialog.ordermed.fulfillRefill.showApprove(item, authRefills, note);
            } else {
                if (item.isControlledRefillPrintOnly()) {
                    el8.appshared.dialog.approveControlledMedPrintOnly.show({
                        refill: item,
                        authRefills: authRefills,
                        note: note
                    });
                } else {
                    el8.appshared.dialog.approveControlledMed.show({
                        refill: item,
                        authRefills: authRefills,
                        note: note
                    });
                }
            }
            container.empty();
            if (closeFn) { closeFn(); }
        } else {
            el8.uiwidget.alert(validated['msg'], authRefillsField.getInputField());
        }
    });
    cancelBtn.on('click', function(e) {
        var authRefills = authRefillsField.getVal();
        var note = noteField.getVal();
        el8.util.amplitude.startCompleteChangeNumberRefillRenewalRxResponse(
            'Cancel', String(item.getAuthRefills()) !== authRefills, Boolean(note)
        );
        container.empty();
        if (closeFn) { closeFn(); }
    });

    var $firstField = $(':input[name="authRefills"]', container);
    container.off('focus', '.tabcatcher').on('focus', '.tabcatcher',  function() {
        $firstField.focusSelect();
    });
    $firstField.focusSelect();

};

el8.appshared.rxRefillRequest.deny = function(item, container, closeFn) {

    if (container.contents().length) { return; }

    // First, populate container with form
    container.html(el8.template.render.rxRefillRequestForm.denial({ 
        isControlled: item.isMedicationControlled() 
    }));

    var noteField = el8.service.infoField.addInfoField({
        field: $(':input[name="note"]', container),
        infoText: 'reason for denial...'
    });

    var denyBtn = $('button[name="deny"]', container);
    var denyWithNewRxBtn = $('button[name="denyWithNewRx"]', container);
    var cancelBtn = $('button[name="cancel"]', container);

    if (el8Globals.FEATURES.SCRIPTv2017071) {
        denyWithNewRxBtn.html('Replace');
    }

    denyBtn.on('click', function(e) {
        var note = noteField.getVal();
        if (note) {
            if (note.trim().length > 70) {
                var message = 'Denial reason exceeds limit of 70 characters.';
                el8.util.amplitude.startCompleteDenyRenewalRxResponse('Deny', message);
                el8.uiwidget.alert(message, noteField.getInputField());
            } else {
                el8.util.amplitude.startCompleteDenyRenewalRxResponse('Deny', null);
                el8.appchart.dialog.ordermed.fulfillRefill.showDeny(item, note);
                container.empty();
                if (closeFn) { closeFn(); }
            }
        } else {
            var message = 'Please fill in a denial reason.';
            el8.util.amplitude.startCompleteDenyRenewalRxResponse('Deny', message);
            el8.uiwidget.alert(message, noteField.getInputField());
        }
    });
    denyWithNewRxBtn.on('click', function(e) {
        el8.util.amplitude.startCompleteDenyRenewalRxResponse('Replace', null);
        var note = noteField.getVal();
        el8.appchart.mgr.orderForm.denyWithNewMedOrder(item, note);
        container.empty();
        if (closeFn) { closeFn(); }
    });
    cancelBtn.on('click', function(e) {
        el8.util.amplitude.startCompleteDenyRenewalRxResponse('Cancel', null);
        container.empty();
        if (closeFn) { closeFn(); }
    });

    var $firstField = $(':input[name="note"]', container);
    container.off('focus', '.tabcatcher').on('focus', '.tabcatcher',  function() {
        $firstField.focusSelect();
    });
    $firstField.focusSelect();

};

el8.appshared.rxRefillRequest.renew = function(item, container, closeFn) {

    if (container.contents().length) { return; }

    // First, populate container with form
    container.html(el8.template.render.rxRefillRequestForm.controlledRenewal());

    var noteField = el8.service.infoField.addInfoField({
        field: $(':input[name="note"]', container),
        infoText: 'reason for renewal (optional)'
    });

    var controlledRxRenewalBtn = $('button[name="controlledRenewal"]', container);
    var cancelBtn = $('button[name="cancel"]', container);

    controlledRxRenewalBtn.on('click', function(e) {
        el8.util.amplitude.startCompleteDenyRenewalRxResponse('Renew', null);
        var note = noteField.getVal();
        el8.appchart.mgr.orderForm.denyWithRefillMedOrder(item, note);
        container.empty();
        if (closeFn) { closeFn(); }
    });

    cancelBtn.on('click', function(e) {
        el8.util.amplitude.startCompleteDenyRenewalRxResponse('Cancel', null);
        container.empty();
        if (closeFn) { closeFn(); }
    });

    var $firstField = $(':input[name="note"]', container);
    container.off('focus', '.tabcatcher').on('focus', '.tabcatcher',  function() {
        $firstField.focusSelect();
    });
    $firstField.focusSelect();

};